<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Crear nueva presentación
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="displayForm">
        <div class="form-group">
            <label for="employeeFormName" class="form-label">Nombre de la presentación</label>
            <input type="text" class="form-control" id="employeeFormName" formControlName="name">
        </div>
        <p *ngIf="displayForm.controls['name'].touched && displayForm.controls['name'].invalid" class="error-message">
            Este campo es requerido </p>
        <div class="form-group">
            <label for="dayToShow" class="form-label">Día</label>
            <select class="form-control" id="dayToShow" formControlName="dayToShow">
                <option value="" disabled>
                    <span>Day To Show</span>
                </option>
                <option value="1">
                    <span>Lunes</span>
                </option>
                <option value="2">
                    <span>Martes</span>
                </option>
                <option value="3">
                    <span>Miércoles</span>
                </option>
                <option value="4">
                    <span>Jueves</span>
                </option>
                <option value="5">
                    <span>Viernes</span>
                </option>
                <option value="6">
                    <span>Sábado</span>
                </option>
                <option value="7">
                    <span>Domingo</span>
                </option>
            </select>
        </div>
        <p *ngIf="displayForm.controls['dayToShow'].touched && displayForm.controls['dayToShow'].invalid"
            class="error-message">Este campo es requerido</p>
    </form>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success" [disabled]="displayForm.invalid || isSaving" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>